import React from 'react';

const SendIcon = ({ stroke = "white", className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.369 4.63329L7.294 10.125M7.29733 10.1241L8.77316 16.765C8.95733 17.5925 10.0565 17.7708 10.4923 17.0441L17.3665 5.58663C17.7423 4.96163 17.2923 4.16663 16.5632 4.16663H3.604C2.76816 4.16663 2.34983 5.17663 2.94066 5.76746L7.29733 10.1241Z",
      stroke,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
SendIcon.displayName = "Icons.SendIcon";

export { SendIcon };
//# sourceMappingURL=SendIcon.js.map
